import React, { useState, useContext, useEffect } from 'react'
import { Input, Modal, Form, Select, Row, Col, Button, DatePicker } from 'antd'
import api from '../../../services/api'
import SL_Button from '../../../components/buttons/Button'
import GeneralContext from '../../../context/GeneralContext/GeneralContext'
import EUsersTypes from '../../../enums/EUsersTypes'
import { ERegExp } from '../../../enums/ERegExp'
import { SL_Date } from "../../../components/date/Date";
import { displayMessage } from '../../../helpers/messages'
import { phoneMask, phoneUnmask, cpfMask, cpfUnmask } from '../../../helpers/iMask'
import { MaskedInput } from 'antd-mask-input';
import dayjs from 'dayjs';

const { Option } = Select
var userTypeList = Object.values(EUsersTypes)
    .filter(userType =>[EUsersTypes.EMPLOYEE.code, EUsersTypes.CLIENT_ADMIN.code].includes(userType.code))
    .map(userType => {
        return (
            { value: userType.code, label: userType.title }
        )
    })
const DATE_FORMAT = 'DD/MM/YYYY'


export default function CreateUser({ handleOnCloseModal, refreshUsers, clientsList, idClient }) {
    const [form] = Form.useForm()

    const {
        setShowLoading,
        mobile_mode,
    } = useContext(GeneralContext)

    // useEffect(() => {
    //     phoneMask('whatsapp-number')
    //     cpfMask('cpf-number')
    // }, [])


    const handleCreateUser = async (values) => {
        setShowLoading(true)
        try {
            let formatedValues = {
                ...values,
                client_id: idClient && idClient != null ? idClient : values.client_id,
                plan_expired: values?.plan_expired ? values.plan_expired.format('YYYY-MM-DD') : null,
                is_active: true,
                whatsapp: values.whatsapp ? phoneUnmask(values.whatsapp) : null,
                cpf: values.cpf ? cpfUnmask(values.cpf) : null,
            }
            console.log(formatedValues)
            await api.user.create(formatedValues)
            await refreshUsers()
            await handleOnCloseModal(true)
            alert(displayMessage('CREATE_USER_SUCCESS'), 'success', displayMessage('SUCCESS'))
        } finally {
            setShowLoading(false)
        }
    }

    // const newLocal = <Form.Item
    //     label={<span className='text-fit-red-900 font-semibold'>{displayMessage('CPF')}:</span>}
    //     name="cpf"
    //     className={`w-full m-0`}
    //     style={{ flex: 1 }}
    // >
    //     {/* <Input type="text" className='text-fit-red-900' id='cpf-number' onChange={() => cpfMask('cpf-number')} /> */}
    //     <MaskedInput mask='000.000.000-00' />
    // </Form.Item>
    const newLocal = <></>
    return (
        <Modal
            title={<div className="text-xl font-bold text-fit-red-900">{displayMessage('REGISTER_USER_2')}</div>}
            open={true}
            onCancel={() => handleOnCloseModal(false)}
            centered={true}
            footer={
                <div className='flex justify-end'>
                    <SL_Button className="w-[150px] bg-gray-500 border-transparent" onClick={() => handleOnCloseModal(false)}>{displayMessage('CLOSE')}</SL_Button>

                    <SL_Button className="w-[150px]" onClick={() => form.submit()}>{displayMessage('END_REGISTER')}</SL_Button>
                </div>
            }
            maskClosable={false}
            width={750}
            bodyStyle={{ overflow: 'auto' }}
        >
            <Form
                onFinish={handleCreateUser}
                layout="vertical"
                requiredMark='optional'
                form={form}
            >
                <div style={{ display: 'flex', gap: 2, flexDirection: 'column', gap: 10 }}>
                    <div style={{ width: '100%', display: 'flex', flexDirection: mobile_mode ? 'column' : 'row', gap: 10 }}>
                        <Form.Item
                            label={<span className='text-fit-red-900 font-semibold'>{displayMessage('FIRST_NAME')}:</span>}
                            name="first_name"
                            className={`w-full m-0`}
                            rules={[{ required: true, message: displayMessage('FIRST_NAME_MANDATORY'), pattern: ERegExp.MUST_HAVE_LETTERS.regexp, whitespace: false }]}
                            style={{ flex: 1 }}
                        >
                            <Input type="text" className='text-fit-red-900' />
                        </Form.Item>
                        <Form.Item
                            label={<span className='text-fit-red-900 font-semibold'>{displayMessage('LAST_NAME')}:</span>}
                            name="last_name"
                            className={`w-full m-0`}
                            rules={[
                                { pattern: ERegExp.MUST_HAVE_LETTERS.regexp, message: displayMessage('INVALID_INPUT_DATA') },
                                { whitespace: false, message: displayMessage('NO_WHITE_SPACE_WARNING') }
                            ]}
                            style={{ flex: 1 }}
                        >
                            <Input type="text" className='text-fit-red-900' />
                        </Form.Item>
                    </div>
                    <div style={{ width: '100%', display: 'flex', flexDirection: mobile_mode ? 'column' : 'row', gap: 10 }}>
                        <Form.Item
                            label={<span className='text-fit-red-900 font-semibold'>{displayMessage('EMAIL')}:</span>}
                            name="email"
                            className={`w-full m-0`}
                            rules={[
                                { required: true, type: 'email' },
                                { whitespace: false, message: displayMessage('NO_WHITE_SPACE_WARNING') }]}
                            style={{ flex: 1 }}
                        >
                            <Input type="text" className='text-fit-red-900' />
                        </Form.Item>
                        {newLocal}
                        <Form.Item
                            label={<span className='text-fit-red-900 font-semibold'>{displayMessage('WHATSAPP')}:</span>}
                            name="whatsapp"
                            className={`w-full m-0`}
                            rules={[
                                { required: false },
                                { whitespace: false, message: displayMessage('NO_WHITE_SPACE_WARNING') }]}
                            style={{ flex: 1 }}
                        >
                            {/* <Input type="text" className='text-fit-red-900' id='whatsapp-number' onChange={() => phoneMask('whatsapp-number')} /> */}
                            <MaskedInput mask='+00 (00) 00000-0000' />
                        </Form.Item>
                    </div>
                    <div style={{ width: '100%', display: 'flex', flexDirection: mobile_mode ? 'column' : 'row', gap: 10 }}>
                        <Form.Item
                            label={<span className='text-fit-red-900 font-semibold'>{displayMessage('USER_TYPE')}:</span>}
                            name="user_type"
                            className={`w-full m-0`}
                            rules={[{ required: true, message: displayMessage('USER_TYPE_MANDATORY') }]}
                            style={{ flex: 1 }}
                        >
                            <Select>
                                {userTypeList.map(option => <Option key={option.value} value={option.value}>{option.label}</Option>)}
                            </Select>
                        </Form.Item>

                        <Form.Item
                            label={<span className='text-fit-red-900 font-semibold'>{displayMessage('CLIENT')}:</span>}
                            name="client_id"
                            className={`w-full m-0`}
                            rules={[{ required: true, message: displayMessage('CLIENT_MANDATORY') }]}
                            style={{ flex: 1 }}
                            initialValue={idClient ? idClient : null}
                        >
                            <Select
                                disabled={idClient}
                            >
                                {idClient ? 
                                <Option key={idClient} value={idClient}>{clientsList.find(client => client.id == idClient).name}</Option> :
                                clientsList.map(client => <Option key={client.id} value={client.id}>{client.name}</Option>)}
                            </Select>
                        </Form.Item>
                    </div>
                    <div style={{ width: '100%', display: 'flex', flexDirection: mobile_mode ? 'column' : 'row', gap: 10 }}>
                        <Form.Item
                            label={<span className='text-fit-red-900 font-semibold'>Validade do Plano:</span>}
                            name="plan_expired"
                            className={`w-full m-0`}
                            style={{ flex: 1 }}
                            extra={<span className='text-gray-500 text-xs'>Deixe vazio para acesso sem limite de tempo</span>}
                        >
                            <DatePicker 
                                format={DATE_FORMAT}
                                placeholder="Selecione a data"
                                style={{ width: '100%' }}
                                allowClear
                            />
                        </Form.Item>
                    </div>
                </div>
            </Form>
        </Modal>
    )
}
